var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoiceApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2611",
    "data-name": "Group 2611",
    transform: "translate(11520 13236)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M26.639,40H2.153A2.165,2.165,0,0,1,0,37.828V3.645A3.633,3.633,0,0,1,3.613,0H31.934A4.573,4.573,0,0,1,36.24,4.791v9.242a2.166,2.166,0,0,1-2.153,2.173H28.793v1.146c-.2-.012-.408-.019-.619-.019-.182,0-.366.005-.547.015V4.791a5.034,5.034,0,0,1,1.485-3.614H3.613A2.46,2.46,0,0,0,1.166,3.645V37.828a.993.993,0,0,0,.988,1H26.639a.993.993,0,0,0,.988-1v-.2c.175.01.359.015.547.015.205,0,.413-.006.619-.019v.2A2.165,2.165,0,0,1,26.639,40ZM31.934,1.176a3.407,3.407,0,0,0-3.141,3.614V15.03h5.294a.993.993,0,0,0,.988-1V4.791A3.406,3.406,0,0,0,31.934,1.176ZM22.19,35.658H8.419a.588.588,0,0,1,0-1.177H20.873a10.167,10.167,0,0,0,1.315,1.175Zm-16.838,0H4.039a.588.588,0,0,1,0-1.177H5.352a.588.588,0,0,1,0,1.177Zm12.88-6.57H8.419a.588.588,0,0,1,0-1.177h9.7a10.331,10.331,0,0,0,.115,1.175Zm-12.88,0H4.039a.588.588,0,0,1,0-1.177H5.352a.588.588,0,0,1,0,1.177Zm14.1-6.662H8.419a.588.588,0,0,1,0-1.176H20.232a10.233,10.233,0,0,0-.784,1.175Zm-14.1,0H4.039a.588.588,0,0,1,0-1.177H5.352a.588.588,0,0,1,0,1.177Zm19.4-5.605H8.419a.588.588,0,0,1,0-1.176H24.755a.588.588,0,0,1,0,1.176Zm-19.4,0H4.039a.588.588,0,0,1,0-1.176H5.352a.588.588,0,0,1,0,1.176ZM14.4,14.049a5.407,5.407,0,1,1,5.358-5.407A5.389,5.389,0,0,1,14.4,14.049Zm0-9.638a4.142,4.142,0,0,0-2.961,1.24A4.183,4.183,0,1,0,14.4,4.411Zm0,7.945a.586.586,0,0,1-.582-.588v-.3a1.76,1.76,0,0,1-1.157-1.655.583.583,0,1,1,1.166,0,.578.578,0,0,0,.574.58H14.5a.58.58,0,0,0,0-1.159h-.216a1.758,1.758,0,0,1-.475-3.446V5.515a.583.583,0,1,1,1.166,0v.3a1.76,1.76,0,0,1,1.157,1.655.587.587,0,0,1-.583.589l-.547-.385-.035-.2a.578.578,0,0,0-.575-.58h-.107a.58.58,0,0,0,0,1.16H14.5a1.616,1.616,0,0,1,1.447.78,2.039,2.039,0,0,1,.293.975A1.762,1.762,0,0,1,14.98,11.5v.27A.586.586,0,0,1,14.4,12.357Z",
    transform: "translate(-11520 -13236)",
    fill: "#74c061"
  }), /*#__PURE__*/React.createElement("g", {
    id: "checked_123",
    "data-name": "checked 123",
    transform: "translate(-11497.613 -13217.384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2612",
    "data-name": "Group 2612",
    transform: "translate(4.182 2.23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2611-2",
    "data-name": "Group 2611"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1907",
    "data-name": "Path 1907",
    d: "M134.5,64.524a.66.66,0,0,0-.939,0l-7.964,8-2.873-3.145a.661.661,0,0,0-.938-.039.673.673,0,0,0-.039.945l3.341,3.657a.661.661,0,0,0,.474.216h.014a.662.662,0,0,0,.469-.2l8.453-8.5A.672.672,0,0,0,134.5,64.524Z",
    transform: "translate(-121.568 -64.327)",
    fill: "#74c061"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2614",
    "data-name": "Group 2614"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2613",
    "data-name": "Group 2613"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1908",
    "data-name": "Path 1908",
    d: "M16.95,8.205a.666.666,0,0,0-.664.669A7.479,7.479,0,1,1,8.807,1.338.669.669,0,0,0,8.807,0a8.874,8.874,0,1,0,8.807,8.874A.666.666,0,0,0,16.95,8.205Z",
    fill: "#74c061"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceApp);
export default __webpack_public_path__ + "static/media/invoiceApp.196afec32c713c3cfdd25cdccce1de62.svg";
export { ForwardRef as ReactComponent };